import React from 'react';
import { App } from '@app/src/view';
import { Loading } from '@app/src/view/Loading';

const NotFound: React.FC = () => (
  <>Not Found</>
);

export const routes = [
  {
    component: App,
    routes: [
      {
        path: '/:token',
        component: Loading,
        exact: true
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
];
